<script setup>
import { useAuth0 } from '@auth0/auth0-vue'

const { loginWithRedirect } = useAuth0()

loginWithRedirect({
  appState: {
    target: '/profile',
  },
})
</script>
